/* Vexaroa AJAX cart: keep every cart badge synced with Shopify's live cart. */
(() => {
  if (window.__vexaroaAjaxCartInstalled) return;
  window.__vexaroaAjaxCartInstalled = true;

  const root = window.Shopify?.routes?.root || '/';
  let refreshRevision = 0;

  async function refresh() {
    const revision = ++refreshRevision;
    try {
      const response = await fetch(`${root}cart.js`, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision !== refreshRevision) return;
      const count = Number(cart.item_count || 0);
      const label = String(count);
      document.querySelectorAll('.cart-bubble').forEach((el) => el.classList.toggle('visually-hidden', count === 0));
      document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"]').forEach((el) => {
        el.textContent = label;
        el.classList.toggle('hidden', count === 0);
      });
      document.querySelectorAll('.vexaroa-mobile-cart-count, [data-cart-count], .vxa-head-link[href$="/cart"] b').forEach((el) => {
        el.textContent = label;
        el.hidden = count === 0;
      });
      document.querySelectorAll('.header-actions__cart-icon').forEach((el) => {
        el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      });
      document.querySelectorAll('.vexaroa-collection-top-cart').forEach((el) => {
        const badge = el.querySelector('span:last-child');
        if (badge) badge.textContent = label;
        const currentLabel = el.getAttribute('aria-label');
        if (currentLabel) el.setAttribute('aria-label', currentLabel.replace(/\(\d+\)/, '(' + label + ')'));
      });
      try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() })); } catch (_) {}
      document.dispatchEvent(new CustomEvent('vexaroa:cart-count-updated', { detail: { itemCount: count, cart } }));
    } catch (error) {
      console.error('Vexaroa cart count update failed', error);
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartMutation = /\/cart\/(add|change|update|clear)(\.(?:js|json))?(?:[?#]|$)/i.test(url);
    return originalFetch.call(this, input, init).then((response) => {
      if (isCartMutation && response.ok) response.clone().json().then(() => refresh()).catch(() => {});
      return response;
    });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const purchase = form.closest('[data-vexaroa-product-purchase]');
    if (purchase && document.querySelector('#MainContent[data-template^="product"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const addButton = form.querySelector('[name="add"]');
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput?.value || addButton?.disabled || form.dataset.submitting === 'true') return;
      if (!form.reportValidity()) return;
      form.dataset.submitting = 'true';
      const button = event.submitter || addButton;
      const buyNow = button?.hasAttribute('data-vexaroa-buy-now');
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      const data = new FormData(form);
      data.delete('return_to');
      fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: data
      }).then(async response => {
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item');
        await refresh();
        window.location.assign(`${root}${buyNow ? 'checkout' : 'cart'}`);
      }).catch(error => {
        const status = purchase.querySelector('[ref="liveRegion"]');
        if (status) status.textContent = error.message;
        form.dataset.submitting = 'false';
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
      return;
    }
    if (form.matches('.vexaroa-collection-cart-form') && form.querySelector('[name="vexaroa-ajax-add"]')) {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      const originalHtml = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const label = button.querySelector('span') || form.querySelector('[data-vexaroa-cart-status]');
      if (label) label.textContent = form.dataset.addingText || 'Adding…';
      const data = new FormData(form);
      data.delete('vexaroa-ajax-add');
      fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      }).then(async (response) => {
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || item.message || form.dataset.errorText || 'Could not add this item');
        await refresh();
        if (label) label.textContent = form.dataset.addedText || 'Added ✓';
      }).catch((error) => {
        if (label) label.textContent = error.message || form.dataset.errorText || 'Try again';
      }).finally(() => {
        setTimeout(() => {
          if (button.isConnected) {
            button.innerHTML = originalHtml;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        }, 1200);
      });
      return;
    }
    if (/\/cart\/add(?:\.js)?(?:[?#]|$)/i.test(form.action || '') || form.querySelector('[name="id"]')) {
      setTimeout(refresh, 500);
      setTimeout(refresh, 1400);
    }
  }, true);

  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  refresh();
})();